<section class="unhandled-bank-transaction-form">
  <app-form-header [menuDefinition]="menuDefinition" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form
      class="unhandled-bank-transaction-form__form astral-content-width astral-stack-l"
      [formGroup]="form"
      >
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['importedAt']"></astral-input>
          <astral-input [control]="form.controls['transactionStatusCaption']"></astral-input>
          <astral-date-picker
            [control]="form.controls['transactionDate']"
            [readonly]="true"
            [model]="dataContext.transactionDate"
            [label]="'BANK_IMPORT_TRANSACTIONS.TRANSACTION_DATE'"
          ></astral-date-picker>
          <astral-input [control]="form.controls['transactionText']"></astral-input>
          <astral-input [control]="form.controls['debtorName']"></astral-input>
          <app-money-box [control]="form.controls['amount']"></app-money-box>
          <astral-input [control]="form.controls['bankAccountNumber']"></astral-input>
          <astral-input [control]="form.controls['companyName']"></astral-input>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
